const routes = [
  {
    index: true,
    label: "cirimia // pic",
    path: "/",
  },
  {
    label: "About",
    path: "/about",
  },
  {
    label: "Contact",
    path: "/contact",
    command: "freq",
  },
];

export default routes;
